import { ApiResponse, UIField, UISchema } from "@bonusmap/api-types";
import { TerritorialSearchResult } from "@bonusmap/shared_ui/library";
export interface TerritorioViewItem {
    name: string;
    type: string; // "regione" | "provincia" | "comune"
    parent_name?: string; // nome del territorio genitore, se applicabile
}
/**
 * questo helper si occupa di recuperare i dati relativi all'ambito territoriale 
 * o da un id singolo o da una lista di id multipli
 */
export async function retrieveAmbito(
    dataSource: UISchema,
    fieldName: string = "ambito_territoriale"): Promise<TerritorioViewItem[]> {
    const uiField: UIField = dataSource[fieldName];
    if (!uiField) {
        return [];
    }
    const ids = uiField.value;
    if (!ids) {
        return [];
    }
    // controlla se ids è già un array di oggetti
    if (Array.isArray(ids) && ids.length > 0 && typeof ids[0] === 'object') {
        // è già un array di oggetti TerritorialSearchResult
        return ids as TerritorioViewItem[];
    }
    let valueArray: string[] = [];
    if (!Array.isArray(ids)) {
        // singolo id
        const singleId = ids as string;
        valueArray = [singleId];
    } else {
        // array di id
        valueArray = ids as string[];
    }
    const result: ApiResponse<TerritorialSearchResult[]> = await window.api.getTerritorialByIds(valueArray);
    if (!result?.success || !result?.data) {
        return [];
    }
    const viewerList:TerritorioViewItem[] = [];
    result.data.forEach(item => {
        let name = item.name;
        let parent_name = "";
        if(item.type=="comune") {
            name = `${item.name} (${item.province_sigla})`;
            parent_name = item.province_name || "";
        }
        const viewerItem: TerritorioViewItem = {
            name,
            type: item.type || 'comune',
            parent_name
        }
        viewerList.push(viewerItem);
    });
    return viewerList;
}